module.exports = __webpack_public_path__ + "static/about4-7d87873675abe698b5f811f52feba3d6.png";